import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d8v8r0q181e9e92u8psg';

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="lg:w-[36%]">
            <Link to="/" className="inline-block cursor-pointer">
              <h3 className="text-xl md:text-2xl font-heading font-bold">
                Hoobuy <span className="font-light italic">Sheet</span>
              </h3>
            </Link>
            <p className="mt-4 text-sm text-white/50 leading-relaxed max-w-sm">
              A melhor Hoobuy Spreadsheet em portugu&ecirc;s. Encontre produtos selecionados, links atualizados e guias completos para suas compras na Hoobuy.
            </p>

            <div className="mt-6">
              <p className="text-xs text-white/40 mb-2 font-medium uppercase tracking-wider">Newsletter</p>
              <form
                data-readdy-form=""
                action={FORM_SUBMIT_URL}
                method="POST"
                className="flex flex-col sm:flex-row gap-2"
              >
                <input
                  type="email"
                  name="email"
                  placeholder="Seu melhor e-mail"
                  required
                  className="flex-1 bg-white/5 border border-white/10 rounded-full px-4 py-2.5 text-sm text-white placeholder:text-white/30 outline-none focus:border-white/30 transition-colors"
                />
                <input
                  type="text"
                  name="phone_alt"
                  autoComplete="off"
                  tabIndex={-1}
                  aria-hidden="true"
                  className="honeypot-field"
                />
                <button
                  type="submit"
                  className="px-5 py-2.5 rounded-full border border-white/20 text-sm font-medium text-white/70 hover:bg-white/10 cursor-pointer whitespace-nowrap transition-all"
                >
                  Assinar
                </button>
              </form>
            </div>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-8">
            <div>
              <h4 className="text-xs font-semibold text-white/40 uppercase tracking-wider mb-3">Produtos</h4>
              <div className="space-y-2.5">
                {categories.slice(0, 6).map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="block text-sm text-white/50 hover:text-white/80 cursor-pointer whitespace-nowrap transition-colors"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-white/40 uppercase tracking-wider mb-3">Mais Categorias</h4>
              <div className="space-y-2.5">
                {categories.slice(6).map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="block text-sm text-white/50 hover:text-white/80 cursor-pointer whitespace-nowrap transition-colors"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-white/40 uppercase tracking-wider mb-3">Guias</h4>
              <div className="space-y-2.5">
                <Link to="/" className="block text-sm text-white/50 hover:text-white/80 cursor-pointer whitespace-nowrap transition-colors">
                  &larr; Voltar ao In&iacute;cio
                </Link>
                <Link to="/guia-de-compras" className="block text-sm text-white/50 hover:text-white/80 cursor-pointer whitespace-nowrap transition-colors">
                  Guia de Compras
                </Link>
                <Link to="/artigo/hoobuy-spreadsheet-guia" className="block text-sm text-white/50 hover:text-white/80 cursor-pointer whitespace-nowrap transition-colors">
                  Guia Completo
                </Link>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-white/50 hover:text-white/80 cursor-pointer whitespace-nowrap transition-colors"
                >
                  Hoobuy Sheet
                </a>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-white/50 hover:text-white/80 cursor-pointer whitespace-nowrap transition-colors"
                >
                  Buy It Now
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-white/40 uppercase tracking-wider mb-3">Artigos SEO</h4>
              <div className="space-y-2.5">
                {articles.slice(0, 5).map((article) => (
                  <Link
                    key={article.slug}
                    to={`/artigo/${article.slug}`}
                    className="block text-sm text-white/50 hover:text-white/80 cursor-pointer transition-colors line-clamp-1"
                  >
                    {article.title}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30">
            &copy; 2026 Hoobuy Sheet. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-white/30 hover:text-white/50 cursor-pointer transition-colors">Termos</a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-white/30 hover:text-white/50 cursor-pointer transition-colors">Pol&iacute;tica</a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-white/30 hover:text-white/50 cursor-pointer transition-colors">Contato</a>
          </div>
        </div>
      </div>
    </footer>
  );
}